<div class="predictive-search">
  <div class="predictive-search__wrapper">
    <label for="predictive_search_{{ predictiveSearchId }}" class="sr-only">
      {{ content.title }}
    </label>
    <input
      #searchInput
      id="predictive_search_{{ predictiveSearchId }}"
      [title]="content.title"
      [placeholder]="content.placeholder"
      [value]="searchText"
      (input)="onInput($event)"
      (focus)="onFocusIn('ONFOCUS')"
      (focusout)="onFocusOut($event)"
      (change)="valueChangeOnInputHandler()"
      autocomplete="off"
      [ngClass]="{
        focus: isDropdownOpen,
        'has-value': searchText !== '',
        error: hasError
      }"
      [attr.aria-invalid]="hasError"
      [attr.aria-describedby]="
        hasError ? 'predictive_search_error_' + predictiveSearchId : null
      "
      [error]="hasError"
      machInput
    />
    <span
      class="predictive-search__wrapper--search-icon"
      [ngClass]="{ 'icon-reposition': !isFocused && searchText === '' }"
    ></span>
    <span
      *ngIf="searchText"
      class="predictive-search__wrapper--cancel-icon"
      (click)="clearSearchText()"
      [tabindex]="0"
      (keypress)="$event.key === 'Enter' && clearSearchText()"
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.001 1.16016L10.1495 9.00098L17.9971 16.8398L16.835 18L8.98834 10.1621L1.1651 17.9766L0.00396729 16.8164L7.82623 9.00098L6.10352e-05 1.18359L1.16217 0.0234375L8.98834 7.84082L16.8389 0L18.001 1.16016Z"
          fill="#6C718A"
        />
      </svg>
    </span>
  </div>
  <div
    *ngIf="hasError && content.errorMessage"
    class="predictive-search--error"
    id="predictive_search_error_{{ predictiveSearchId }}"
    role="alert"
  >
    {{ content.errorMessage }}
  </div>
</div>
<ul
  *ngIf="isDropdownOpen && content.items.length > 0"
  class="predictive-search__list"
  [ngClass]="{
    'predictive-search__list__transparent': content.transparentSearch
  }"
  role="listbox"
  (keydown)="handleListOptionKeyDown($event)"
  (focusout)="onFocusOut($event)"
  aria-label="predictive_search_list"
>
  <li
    #listOption
    *ngFor="let item of content.items; index as i"
    role="option"
    class="predictive-search__list__item"
    title="{{ item.label }}"
    (click)="selectOption(i)"
    [ngClass]="{
      active: activeOptionIndex === i,
      'predictive-search__list__transparent__item': content.transparentSearch
    }"
    tabindex="-1"
  >
    <span
      class="predictive-search__list__item__content"
      [ngClass]="{
        'predictive-search__list__transparent__item__content':
          content.transparentSearch
      }"
    >
      <span
        class="predictive-search__list__item__content--label"
        [ngClass]="{
          'predictive-search__list__transparent__item__content--label':
            content.transparentSearch
        }"
        [innerHTML]="item.label"
      ></span>
      {{ item.value }}
    </span>
  </li>
</ul>
